import { create } from "zustand";
import { persist } from "zustand/middleware";

type TenantState = {
  orgId: string | null;
  orgName: string | null;
  financialYear: string | null;
  financialYearId: string | null;
  setTenant: (orgId: string, orgName: string, financialYear: string, financialYearId?: string | null) => void;
  clearTenant: () => void;
};

export const useTenantStore = create<TenantState>()(
  persist(
    (set) => ({
      orgId: null,
      orgName: null,
      financialYear: null,
      financialYearId: null,
      setTenant: (orgId, orgName, financialYear, financialYearId) => set({ orgId, orgName, financialYear, financialYearId: financialYearId ?? null }),
      clearTenant: () => set({ orgId: null, orgName: null, financialYear: null, financialYearId: null })
    }),
    { name: "accounting-spa-tenant" }
  )
);
